// Слияние порций ленты в памяти — чистая функция, без React.

import type { FeedMessage } from '../api/alertFeedApi';

/** Сколько сообщений держит опрос. Старше — «Показать раньше» на экране ленты. */
export const FEED_MEMORY_LIMIT = 100;

/** Момент сообщения в мс. Микросекунды сервера не нужны: у точки одно сообщение за прогон. */
export function instant(iso: string): number {
  return Date.parse(iso);
}

/**
 * Новая порция поверх известного: дубли по id убираются, новые первыми, не больше 100.
 *
 * `hasMore` — за курсором больше, чем пришло (устройство долго было без сети): прежний
 * хвост отбрасывается, иначе в середине списка осталась бы дыра, которую никто не заметит.
 */
export function mergeFeed(
  known: readonly FeedMessage[],
  page: readonly FeedMessage[],
  hasMore: boolean,
): FeedMessage[] {
  const seen = new Set<string>();
  const merged: FeedMessage[] = [];
  for (const message of [...page, ...(hasMore ? [] : known)]) {
    if (seen.has(message.id)) continue;
    seen.add(message.id);
    merged.push(message);
  }
  merged.sort((a, b) => instant(b.created_at) - instant(a.created_at));
  return merged.slice(0, FEED_MEMORY_LIMIT);
}

/** Сколько сообщений новее отметки. Нет отметки — ноль: история не «новая». */
export function unreadCount(messages: readonly FeedMessage[], mark: string | null): number {
  if (mark === null) return 0;
  const since = instant(mark);
  return messages.filter((message) => instant(message.created_at) > since).length;
}
